import {
    getData,
} from './Services'

export const getAccionesLista = async () => {
    const res = await getData('/acciones');
    return res
}
